<div class="app-layout-container">
    <header>
        <app-header></app-header>
    </header>
    <section class="body">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
        <footer class="footer">
            <app-footer></app-footer>
        </footer>
    </section>
</div>